import { connect } from 'react-redux'
import Menu from './Menu'
import menuSelector from './menuSelector'
import requestFollowCard from '../../sagas/requestFollowCard'
import requestUnarchiveCard from '../../sagas/requestUnarchiveCard'
import requestDeleteCard from '../../sagas/requestDeleteCard'
import requestArchiveCard from '../../sagas/requestArchiveCard'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  menuSelector,
  {
    requestFollowCard,
    requestArchiveCard,
    requestUnarchiveCard,
    requestDeleteCard
  }
)(Menu))
